export default __webpack_public_path__ + "static/media/NoNotifications.490566d5.svg";